import { render, staticRenderFns } from "./novoAnotacoes.vue?vue&type=template&id=345ce97e"
import script from "./novoAnotacoes.vue?vue&type=script&lang=js"
export * from "./novoAnotacoes.vue?vue&type=script&lang=js"
import style0 from "./novoAnotacoes.vue?vue&type=style&index=0&id=345ce97e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports